module.exports = __webpack_public_path__ + "static/media/singapore.ea4861a9.jpg";